import React from 'react';
import { Header } from '../../node_modules/semantic-ui-react';

export default function Project(props) {
    return(
        <div className='section' id='project'>
            <Header as='h3'>
            Project
            </Header>
            <div>
            <div className="section-content">
                <span className='title'><a className='underline' href='https://exprgram.kyungjejo.com'>Exprgram </a></span>
                Exprgram supports context-based video browsing for language learning. We adopt <i>learnersourcing</i> to generate context labels of videos (e.g., relationship, location, formality of langaue) in a scalable way.
            </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Research.jsx